import { pinchDetectorComponent } from './pinch-detector';
import { pinchScaleComponent } from './pinch-scale';
import { tapCursorComponent } from './tap';
import { markerhandleComponent } from './markerhandler';
import { imageMarkerhandlerComponent } from './image-markerhandler';

import { faceSceneInitComponent } from './face-scene-init';
import { moveCollectComponent } from './move-collect';
import followCameraInitComponent from './follow-camera';

import webarSceneComponent from './webar-scene';
import { holdDragInitComponent } from './hold-drag';
import { curvatorComponent } from './curvator';
import { videoClickComponent } from './video-click';
import { gestureHandlerComponent } from './gesture-handler';
import { gestureDetectorComponent } from './gesture-detector';
import { morphFaceComponent } from './face-morph';

// import { twofingerRotate } from './twofinger-rotate';

class AframeListener {
  constructor() {
    window.AFRAME.registerComponent('webar-scene', webarSceneComponent);
    window.AFRAME.registerComponent('tap-cursor', tapCursorComponent);
    window.AFRAME.registerComponent('pinch-detector', pinchDetectorComponent);
    window.AFRAME.registerComponent('pinch-scale', pinchScaleComponent);
    window.AFRAME.registerComponent('markerhandler', markerhandleComponent);
    window.AFRAME.registerComponent(
      'image-markerhandler',
      imageMarkerhandlerComponent
    );

    window.AFRAME.registerComponent('face-scene-init', faceSceneInitComponent);
    window.AFRAME.registerComponent('move-collect', moveCollectComponent);
    window.AFRAME.registerComponent('follow-camera', followCameraInitComponent);
    window.AFRAME.registerComponent('hold-drag', holdDragInitComponent);
    window.AFRAME.registerComponent('curvator', curvatorComponent);
    window.AFRAME.registerComponent('video-click', videoClickComponent);
    // window.AFRAME.registerComponent('twofinger-rotate', twofingerRotate);

    window.AFRAME.registerComponent('gesture-handler', gestureHandlerComponent);
    window.AFRAME.registerComponent(
      'gesture-detector',
      gestureDetectorComponent
    );

    window.AFRAME.registerComponent('face-morph', morphFaceComponent);
  }
}

export { AframeListener };
